/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { getFloatingPref } from 'services/academy_floating';
import { AcademyTypes, AcademyState } from './types';

const flags = (loading: boolean, loaded: boolean, error: boolean) => ({ loading, loaded, error });

const INITIAL_STATE: AcademyState = {
  agenda: [],
  liveNow: null,
  contents: [],
  mySubscriptions: [],
  floatingState: 'expanded',
  request: {
    agenda: flags(false, false, false),
    liveNow: flags(false, false, false),
    contents: flags(false, false, false),
    mySubscriptions: flags(false, false, false),
    subscribe: flags(false, false, false),
  },
};

const reducer: Reducer<AcademyState> = (state = INITIAL_STATE, action) => {
  const { type, result, payload, id } = action as any;

  return produce(state, (draft) => {
    switch (type) {
      case AcademyTypes.GET_AGENDA_REQUEST:
        draft.request.agenda = flags(true, false, false);
        break;
      case AcademyTypes.GET_AGENDA_SUCCESS:
        draft.agenda = Array.isArray(result?.data) ? result.data : [];
        draft.request.agenda = flags(false, true, false);
        break;
      case AcademyTypes.GET_AGENDA_FAILURE:
        draft.request.agenda = flags(false, false, true);
        break;

      case AcademyTypes.GET_LIVE_NOW_REQUEST:
        draft.request.liveNow = flags(true, false, false);
        break;
      case AcademyTypes.GET_LIVE_NOW_SUCCESS: {
        const live = result?.data?.live || null;
        draft.liveNow = live;
        // Hidrata o estado do flutuante junto com a live (evita o "flash" no reload).
        draft.floatingState = live ? getFloatingPref(live.id) : 'expanded';
        draft.request.liveNow = flags(false, true, false);
        break;
      }
      case AcademyTypes.GET_LIVE_NOW_FAILURE:
        draft.request.liveNow = flags(false, false, true);
        break;

      case AcademyTypes.GET_CONTENTS_REQUEST:
        draft.request.contents = flags(true, false, false);
        break;
      case AcademyTypes.GET_CONTENTS_SUCCESS:
        draft.contents = Array.isArray(result?.data) ? result.data : [];
        draft.request.contents = flags(false, true, false);
        break;
      case AcademyTypes.GET_CONTENTS_FAILURE:
        draft.request.contents = flags(false, false, true);
        break;

      case AcademyTypes.GET_MY_SUBSCRIPTIONS_REQUEST:
        draft.request.mySubscriptions = flags(true, false, false);
        break;
      case AcademyTypes.GET_MY_SUBSCRIPTIONS_SUCCESS:
        draft.mySubscriptions = Array.isArray(result?.data) ? result.data : [];
        draft.request.mySubscriptions = flags(false, true, false);
        break;
      case AcademyTypes.GET_MY_SUBSCRIPTIONS_FAILURE:
        draft.request.mySubscriptions = flags(false, false, true);
        break;

      case AcademyTypes.SUBSCRIBE_REQUEST:
        draft.request.subscribe = flags(true, false, false);
        break;
      case AcademyTypes.SUBSCRIBE_SUCCESS: {
        const sub = result?.data;
        const current = Array.isArray(state.mySubscriptions) ? state.mySubscriptions : [];
        if (sub) {
          draft.mySubscriptions = [sub, ...current.filter((item) => item.id !== sub.id)];
        }
        draft.request.subscribe = flags(false, true, false);
        break;
      }
      case AcademyTypes.SUBSCRIBE_FAILURE:
        draft.request.subscribe = flags(false, false, true);
        break;

      case AcademyTypes.UNSUBSCRIBE_SUCCESS:
        draft.mySubscriptions = (
          Array.isArray(state.mySubscriptions) ? state.mySubscriptions : []
        ).filter((item) => item.id !== id);
        break;

      case AcademyTypes.SET_LIVE_NOW: {
        const live = payload || null;
        draft.liveNow = live;
        draft.floatingState = live ? getFloatingPref(live.id) : 'expanded';
        break;
      }

      case AcademyTypes.SET_FLOATING_STATE:
        draft.floatingState = payload === 'minimized' ? 'minimized' : 'expanded';
        break;

      default:
    }
  });
};

export default reducer;
